import { Route, Routes } from 'react-router-dom'
import SeoManager from './components/SeoManager.jsx'
import PageMotion from './components/PageMotion.jsx'
import ScrollManager from './components/ScrollManager.jsx'
import SmoothScroll from './components/SmoothScroll.jsx'
import SiteShell from './layout/SiteShell.jsx'
import AcademicEdgePolicyPage from './pages/AcademicEdgePolicyPage.jsx'
import EdgezpacePolicyPage from './pages/EdgezpacePolicyPage.jsx'
import HomePage from './pages/HomePage.jsx'
import NotFoundPage from './pages/NotFoundPage.jsx'
import PrivacyPage from './pages/PrivacyPage.jsx'
import AboutPage from './pages/AboutPage.jsx'

export default function App() {
  return (
    <>
      <SeoManager />
      <ScrollManager />
      <SmoothScroll />
      <SiteShell>
        <div className="route-view">
          <PageMotion />
          <Routes>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="privacy/academic-edge" element={<AcademicEdgePolicyPage />} />
            <Route path="privacy/edgezpace" element={<EdgezpacePolicyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </SiteShell>
    </>
  )
}
